<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/Task/TaskList"><span
                        class="mdi mdi-arrow-left"></span></a> Edit Task</h4>
        </div>

        <div class="card">
            <div class="card-body">
                <form [formGroup]="registerForm">
                    <div class="form-row projectactivity">
                        <div class="form-group col-lg-3 col-md-3 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Task id
                            </label>
                            <input class="form-control-plaintext" type="text" formControlName="TaskId" readonly />
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="proname==true">
                            <label for="" class="d-flex justify-content-between align-items-center">Project Name
                                (Project ID)</label>
                            <input class="form-control-plaintext" type="text" formControlName="ProjectName" readonly />
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="inqname==true">
                            <label for="" class="d-flex justify-content-between align-items-center">Inquiry Name
                                (Inquiry ID)</label>
                            <input class="form-control-plaintext" type="text" formControlName="InquiryName" readonly />
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block"><i class="fas fa-theater-masks"></i>Task Title<span
                                    class="required ml-1">*</span></label>
                            <angular2-multiselect formControlName="TaskTitle" [data]="selected_Title"
                                [settings]="dropdownTask_Titile" [(ngModel)]="selectedTitle">
                            </angular2-multiselect>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block">Task Status<span class="required ml-1">*</span></label>
                            <angular2-multiselect formControlName="TaskStatus" [data]="TaskStatus1"
                                [ngClass]="{ 'is-invalid': submitted && f.TaskStatus.errors }"
                                [(ngModel)]="selectedStatus" [settings]="dropdownTaskStatus"
                                (onSelect)="onStatusSelect($event,Confirm)"
                                [ngClass]="{ 'is-invalid': submitted && f.TaskStatus.errors }">
                            </angular2-multiselect>
                            <div *ngIf="submitted && f.TaskStatus.errors" class="invalid-feedback">
                                <div *ngIf="f.TaskStatus.errors.required">
                                    Task Status is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="userid == 1 || userid == createdby">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Start
                                Date<span class="required ml-1">*</span></label>
                            <div class="input-group">
                                <input type="text" class="form-control " id="inlineFormInputGroup"
                                    placeholder="DD/MM/YYYY" bsDatepicker formControlName="StartDate"
                                    [ngClass]="{ 'is-invalid': submitted && f.StartDate.errors }"
                                    (keydown)="disableDate()" [maxDate]="maxStartDate" (ngModelChange)="newFunc($event)"
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                                </div>
                                <div *ngIf="submitted && f.StartDate.errors" class="invalid-feedback">
                                    <div *ngIf="f.StartDate.errors.required">
                                        Start Date is required.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12"
                            *ngIf="(userid == asnto  && asnto != 1) && userid != createdby">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Start
                                Date<span class="required ml-1">*</span></label>
                            <input class="form-control-plaintext" type="text" formControlName="StartDate" readonly />
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="userid == 1 || userid == createdby">
                            <label for="" class="d-inline-block justify-content-between align-items-center">End
                                Date<span class="required ml-1">*</span></label>
                            <div class="input-group">
                                <input type="text" class="form-control " id="inlineFormInputGroup"
                                    placeholder="DD/MM/YYYY" bsDatepicker formControlName="EndDate"
                                    [ngClass]="{ 'is-invalid': submitted && f.EndDate.errors }"
                                    (keydown)="disableDate()" (ngModelChange)="newFunc2($event)" [minDate]="maxEndDate"
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                                </div>
                                <div *ngIf="submitted && f.EndDate.errors" class="invalid-feedback">
                                    <div *ngIf="f.EndDate.errors.required">
                                        End Date is required.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12"
                            *ngIf="(userid == asnto  && asnto != 1) && userid != createdby">
                            <label for="" class="d-inline-block justify-content-between align-items-center">End
                                Date<span class="required ml-1">*</span></label>
                            <input class="form-control-plaintext" type="text" formControlName="EndDate" readonly />
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Assigned
                                To<span class="required ml-1">*</span></label>
                            <input class="form-control" type="text"
                                *ngIf="(userid == asnto  && asnto != 1) && userid != createdby"
                                formControlName="AssignedToUserName" [(ngModel)]="selectedAssignedToName" readonly />
                            <angular2-multiselect formControlName="AssignedToUserName"
                                *ngIf="userid == 1 || userid == createdby" [data]="AssignedTo1"
                                [ngClass]="{ 'is-invalid': submitted && f.AssignedToUserName.errors }"
                                [(ngModel)]="selectedAssignedTo" [settings]="dropdownAssignedTo"
                                (onSelect)="onAssignedToSelect($event)">
                            </angular2-multiselect>

                            <div *ngIf="submitted && f.AssignedToUserName.errors" class="invalid-feedback">
                                <div *ngIf="f.AssignedToUserName.errors.required">
                                    Assigned To is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="userid == 1 || userid == createdby">
                            <label for="" class="d-flex">Task Followers</label>
                            <angular2-multiselect formControlName="TaskFollowers" [data]="TaskFollowers1"
                                [(ngModel)]="selectedTaskFollowers" [settings]="dropdownTaskFollowers"
                                (onSelect)="onTaskFollowers($event)" (onDeSelect)="onTaskFollowers($event)"
                                (onSelectAll)="onTaskFollowers($event)" (onDeSelectAll)="onTaskFollowers($event)">
                            </angular2-multiselect>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12"
                            *ngIf="(userid == asnto  && asnto != 1) && userid != createdby">
                            <label for="" class="d-flex">Task Followers</label>
                            <angular2-multiselect formControlName="TaskFollowers" [data]="selectedTaskFollowersass"
                                [settings]="dropdownTaskFollowersass" [(ngModel)]="selectedTaskFollowersass">
                            </angular2-multiselect>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block">Task Priority<span
                                    class="required ml-1">*</span></label>
                            <angular2-multiselect formControlName="TaskPriorityName"
                                *ngIf="userid == 1 || userid == createdby" [data]="TaskPriority1"
                                [(ngModel)]="selectedPriority" [settings]="dropdownTaskPriority"
                                (onSelect)="onPrioritySelect($event)" (onDeSelect)="onDePrioritySelect($event)"
                                (onDeSelectAll)="onDePrioritySelect($event)"
                                [ngClass]="{ 'is-invalid': submitted && f.TaskPriorityName.errors }">
                            </angular2-multiselect>

                            <div *ngIf="submitted && f.TaskPriorityName.errors" class="invalid-feedback">
                                <div *ngIf="f.TaskPriorityName.errors.required">
                                    Task Priority required.
                                </div>
                            </div>

                            <input class="form-control" type="text"
                                *ngIf="(userid == asnto  && asnto != 1) && userid != createdby"
                                formControlName="TaskPriorityName" [(ngModel)]="selectedPriorityName" readonly />
                        </div>

                        <div class="w-100"></div>

                        <div class="form-group col-lg-6 col-md-6 col-sm-12" *ngIf="userid == 1 || userid == createdby">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Task
                                Description<span class="required ml-1">*</span></label>
                            <textarea class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.TaskDescription.errors }"
                                formControlName="TaskDescription" maxlength="700"></textarea>
                            <div *ngIf="submitted && f.TaskDescription.errors" class="invalid-feedback">
                                <div *ngIf="f.TaskDescription.errors.required">
                                    Task Description is required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-lg-6 col-md-6 col-sm-12"
                            *ngIf="(userid == asnto  && asnto != 1) && userid != createdby">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Task
                                Description<span class="required ml-1">*</span></label>
                            <textarea class="form-control" formControlName="TaskDescription" maxlength="700"
                                readonly></textarea>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 col-sm-12" *ngIf="userid == 1 || userid == createdby">
                            <label for="" class="d-flex justify-content-between align-items-center">Remark</label>
                            <textarea class="form-control" formControlName="Remark" maxlength="700"></textarea>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 col-sm-12"
                            *ngIf="(userid == asnto  && asnto != 1) && userid != createdby">
                            <label for="" class="d-flex justify-content-between align-items-center">Remark</label>
                            <textarea class="form-control" formControlName="Remark" readonly maxlength="700"></textarea>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 col-sm-12" *ngIf="userid == asnto">
                            <label for="" class="d-flex justify-content-between align-items-center">Action Taken</label>
                            <textarea class="form-control" formControlName="ActionTaken" maxlength="700"></textarea>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 col-sm-12"
                            *ngIf="(userid == 1 || userid == createdby) && userid != asnto">
                            <label for="" class="d-flex justify-content-between align-items-center">Action Taken</label>
                            <textarea class="form-control" formControlName="ActionTaken" maxlength="700"
                                readonly></textarea>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 col-sm-12"
                            *ngIf="(userid == asnto  && asnto != 1) && userid != createdby">
                            <label for="" class="d-flex justify-content-between align-items-center">Outcome
                                Remark</label>
                            <textarea class="form-control" formControlName="OutcomeRemark" maxlength="700"
                                readonly></textarea>
                        </div>
                        <div class="form-group col-lg-6 col-md-6 col-sm-12" *ngIf="userid == 1 || userid == createdby">
                            <label for="" class="d-flex justify-content-between align-items-center">Outcome
                                Remark</label>
                            <textarea class="form-control" formControlName="OutcomeRemark" maxlength="700"></textarea>
                        </div>
                    </div>

                    <div class="row form-row mt-1">
                        <div class="col-lg-12">
                            <a href="javascript:void(0);" class="btn btn-info" (click)="onSubmit()">Save</a>
                            <a href="javascript:void(0);" class="btn btn-danger ml-2"
                                routerLink="/Task/TaskList">Cancel</a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #Confirm>
    <div class="modal-header">
        <h4 class="modal-title text-dark"><strong>Task Status</strong></h4>
        <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
            aria-label="Close"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body text-center">
        <p class="text-left mb-2">Do you want to mark "{{selectedStatusName}}"
            <br>
            <br>
            Note - this task can't be reopened once Closed / Cancel.
        </p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm" [disabled]="delNameDel"
            (click)="decline1(); modalRef.hide();">Yes</button>
        <button type="button" class="btn btn-sm btn btn-secondary ml-2"
            (click)="decline(); modalRef.hide();">Cancel</button>
    </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>